import { InputProduto } from "..";
import { UserData } from "../../../../../contexts/AuthContext";
import minusculoExcetoPrimeira from "../../../../../helpers/minusculoExcetoPrimeira";

export function gerarMensagem(
    selecionados: Array<InputProduto>,
    observacao: string,
    user: UserData | null
): string {

    const loja = user?.perfis_vinculados.find(perfil => perfil.loja);

    const memoValoresTable = selecionados.reduce((agrupado: Array<TAgrupadoValores>, item) => {
        const indice = agrupado.findIndex(obj => obj.departamento === minusculoExcetoPrimeira(item.departamento));
        if (indice === -1) {
            agrupado.push({
                departamento: minusculoExcetoPrimeira(item.departamento),
                data: [item]
            });
        } else {
            agrupado[indice].data.push(item);
        }
        return agrupado;
    }, []);

    return `<b>Loja Solicitante:</b> ${loja?.loja?.id} - ${loja?.loja?.nome}<br><b>Usuário Solicitante:</b> ${user?.nome}
    ${memoValoresTable.map(i => {
        return (
            `<div style='font-size: 16px; font-weight: bold; margin-top: 12px;'>${i.departamento}</div><table border={1} width="100%" style="margin-top: 12px;"><tr>
<th width="100">Código</th>
<th>Produto</th>
<th width="200">Setor</th>
<th width="150">Quantidade</th>
<th width="150">Encomenda</th>
</tr>${i?.data.map(value => (`
    <tr>
    <td>${value.codigo}</td>
    <td>${value.nome}${value.nao_sugerido ? "<span style=' display: block;color: red; font-size: 12px;'>Item não sugerido</span>" : ""}</td>
    <td>${value.setor}</td>
    <td align="center">${value.quantidade}</td>
    <td align="center">${value.encomenda ? value.encomenda : '-'}</td>
    </tr>
    `)).join("")}</table>`
        )
    }).join("")
        }
${observacao}
Atenciosamente,
${user?.nome}
    `;
}

type TAgrupadoValores = {
    departamento: string,
    data: Array<InputProduto>
} 